import {
  BlogSingleBanner,
  BlogSingleBody,
  BlogSingleHero,
} from "@modules/study/blog/blog_single";
import { Fragment } from "react";

import API from "@unisearch/helpers/api";
import { LayoutMain } from "@unisearch/theme/layout";
import { excerptWithRemoveQuote } from "@unisearch/helpers";

const BlogSingle = ({ pageData, blog_slug }) => {
  const data = { ...pageData };
  data.author = {
    authorName: pageData?.author?.name,
    profileImageSrc: pageData?.profileImage?.src,
  };

  const desc =
    data && data?.metaDescription
      ? data?.metaDescription
      : data?.content
      ? excerptWithRemoveQuote(data?.content, 150)
      : "";

  const JsonLd = () => {
    {
      return {
        __html: `
        [
          {
            "@context": "https://schema.org",
            "@type": "Organization",
            "name": "UniSearch",
            "alternateName": "UniSearch",
            "url": "https://myunisearch.com/",
            "logo": "${process.env.NEXT_PUBLIC_URL}/assets/logo_dark.png",
            "sameAs": [
              "https://www.facebook.com/UniSearchIndia",
              "https://twitter.com/myunisearch",
              "https://www.youtube.com/channel/UCCHQrxOr5olDBxypJUE7qZw",
              "https://myunisearch.com/"
            ]
          },
          {
          "@context": "https://schema.org",
          "@type": "BlogPosting",
          "mainEntityOfPage": {
               "@type": "WebPage",
               "@id": "${process.env.NEXT_PUBLIC_URL}/blog/${blog_slug}"
          },
          "headline": "${data?.metaTitle ? data?.metaTitle : data?.title}",
          "description":"${desc} | UniSearch",
          "image": "${data?.posterImage?.src || data?.featureImage?.src}",
          "author": {
               "@type": "Organization",
               "name": "UniSearch"
          },
          "datePublished": "${data?.publishDate}"
     }]
    `,
      };
    }
  };

  return (
    <Fragment>
      <LayoutMain
        ogType="article"
        isLeadPopup={true}
        isHeaderSticky={true}
        title={data?.title}
        metaTitle={data?.metaTitle || data?.title}
        metaKeywords={data?.metaKeyword || "unisearch, blog"}
        metaDescription={data?.metaDescription}
        metaImage={data?.posterImage?.src || data?.featureImage?.src}
        metaUrl={`${process.env.NEXT_PUBLIC_URL}/blog/${blog_slug}`}
        JsonLd={JsonLd}
      >
        <BlogSingleHero pageData={data} />
        <BlogSingleBanner blog={pageData} />
        <BlogSingleBody pageData={pageData} />
      </LayoutMain>
      {/* <ScrollPopup /> */}
    </Fragment>
  );
};

export default BlogSingle;

export async function getServerSideProps({ query }) {
  const { blog_slug } = query;
  let props = {
    pageData: "",
    relatedBlogList: "",
    fakeViewData: "",
    blog_slug,
  };

  try {
    const blogDetail = await API.get(`/public/blog-page/${blog_slug}`);
    if (!blogDetail.error && blogDetail.data) {
      props.pageData = blogDetail.data;
    } else {
      return {
        redirect: {
          permanent: false,
          destination: "/404",
        },
      };
    }
    return {
      props,
    };
  } catch (err) {
    return {
      props,
    };
  }
}
